import { useLocalization } from '@/hooks/useLocalization';
import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import { useTranslations } from 'next-intl';
import FeaturedEcommerceButton from '@/components/design-system/FeaturedEcommerceButton';
import { Button } from '../../../../../components/design-system';
import AddressModal from '../../components/commons/AddressModal/AddressModal';
import useAddressSearch from '../../components/commons/AddressModal/hook';
import QuantityManager from '../../components/commons/QuantityManager';
import useProduct from '../../components/hooks/useProduct';

interface Props {
  product: SearchProduct;
}

export default function ButtonCart({ product }: Props) {
  const t = useTranslations('shop');
  const tCommon = useTranslations('common');
  const { quantityInCart, addToCart, removeFromCart } = useProduct(product);
  const { az, deliveryType } = useLocalization();
  const { updateGlobalLocation } = useAddressSearch('');

  if (!az) {
    return (
      <AddressModal
        showSavedAddresses
        showLastAddress
        onChangeAddress={updateGlobalLocation}
        renderTrigger={({ open }) => (
          <Button size="lg" variant="block" onClick={open}>
            {t('detail.price.addToCart')}
          </Button>
        )}
      />
    );
  }

  if (product.deliveryType !== deliveryType) {
    return <FeaturedEcommerceButton product={product} />;
  }

  if (!product.inStock) {
    return (
      <Button size="lg" variant="block" disabled>
        {tCommon('Availability.NotAvailable')}
      </Button>
    );
  }

  return (
    <>
      {quantityInCart === 0 ? (
        <Button size="lg" variant="block" onClick={addToCart}>
          {t('detail.price.addToCart')}
        </Button>
      ) : (
        <QuantityManager
          quantity={quantityInCart}
          size="lg"
          onAdd={addToCart}
          onSub={removeFromCart}
        />
      )}
    </>
  );
}
